import type { ProRenderFieldPropsType } from '@ant-design/pro-provider'
import { t } from '@lingui/core/macro'
import { Typography } from 'antd'

export const activeBooleanValueType: ProRenderFieldPropsType = {
  render: (text: boolean | null | undefined) => {
    if (text == null) return '-'
    return text ? (
      <Typography.Text type="success">{t`Ja`}</Typography.Text>
    ) : (
      <Typography.Text type="danger">{t`Nein`}</Typography.Text>
    )
  },
  renderFormItem: text => text,
}
